var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.077 12.826C17.077 12.2514 16.5963 11.7856 16.0032 11.7856L12.0482 11.7856V7.18659C12.0482 6.61197 11.5674 6.14616 10.9743 6.14616C10.3813 6.14616 9.90053 6.61197 9.90053 7.18659V12.8167C9.90044 13.2004 10.1184 13.553 10.4675 13.7341C10.6227 13.8184 10.8017 13.8664 10.9921 13.8664H16.0032C16.5963 13.8664 17.077 13.4006 17.077 12.826ZM21.8906 10.5581C22.3948 10.5581 22.674 10.162 22.674 9.67347C22.674 4.96004 17.8156 0 11.869 0C5.31394 0 0 5.1487 0 11.5C0 17.8513 5.31394 23 11.869 23C13.2879 23 13.6954 22.9664 15 22.5C15.4711 22.3303 15.7121 21.8236 15.5391 21.3664C15.3656 20.9077 14.8412 20.6721 14.3677 20.8402C13.2752 21.2308 13.075 21.2308 11.9029 21.2308H11.869C6.3225 21.2308 1.826 16.8741 1.826 11.5C1.826 6.1259 6.3225 1.76923 11.869 1.76923C17.4156 1.76923 20.9776 7.70183 20.9776 9.67347C20.9776 10.162 21.3863 10.5581 21.8906 10.5581ZM21.6077 13.3846V20.0543L22.4414 19.2465C22.7979 18.9011 23.376 18.9011 23.7326 19.2465C24.0891 19.592 24.0891 20.1522 23.7326 20.4976L21.2979 22.8566C20.9413 23.2021 20.3632 23.2021 20.0067 22.8566L17.572 20.4976C17.2154 20.1522 17.2154 19.592 17.572 19.2465C17.9286 18.9011 18.5067 18.9011 18.8632 19.2465L19.7817 20.1366V13.3846C19.7817 12.8961 20.1905 12.5 20.6947 12.5C21.199 12.5 21.6077 12.8961 21.6077 13.3846Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDown);
export default __webpack_public_path__ + "static/media/time_down.b6414da1c7fabcf34fc0a66c90318901.svg";
export { ForwardRef as ReactComponent };